import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'

const ResultByStatusInfo = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The Test Case Results by Status report and accompanying Donut Chart provide a
        comprehensive overview of test case distribution based on their status.
        This visualization displays the percentage of test cases for each status,
        along with the total number of test cases that fall within the applied filters at the dashboard level.
      </Color>
    </Paragraph>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        Key Features:
      </Color>
      <br />
    </Paragraph>
    <List variant='description'>
      <Paragraph>
        <Color variant='theme-description-text'>
          Status Breakdown: The donut chart presents a representation of the distribution of
          test cases across different statuses, enabling quick comprehension of their relative proportions.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Statuses: By clicking on each status, you can access a detailed view of test case results.
          This facilitates focused analysis and investigation.
        </Color>
      </Paragraph>
    </List>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        The Test Case Results by Status report and Donut Chart provide valuable insights into the status distribution of your test cases,
        allowing you to easily track and understand their overall performance. This empowers you to identify trends,
        focus on specific status, and make data-driven decisions to enhance your testing process.
      </Color>
    </Paragraph>
  </>

export default ResultByStatusInfo
